var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"mt-5",staticStyle:{"max-width":"20% !important"},attrs:{"items":_vm.items,"label":_vm.label,"dense":"","item-text":"name","item-value":"rid","value":_vm.value,"clearable":""},on:{"change":(e) => _vm.$emit(`change`, e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }